import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mafc/trolly';
import TYPOGRAPHY from 'theme/typography';
import { ReactComponent as CodIcon } from 'assets/svgs/icon-cod-cart-checkout.svg';

import { getFormattedPrice } from 'utils/price.util';
import useOrderSummary from 'common/OrderSummary/hooks/useOrderSummary.hook';
import { CashOnDeliveryContainer, Container, PriceText } from './cashOnDeliveryItem.styles';

const CashOnDeliveryItem: React.FC<{}> = () => {
  const { totalCodFee } = useOrderSummary();
  const { t } = useTranslation();

  return (
    <CashOnDeliveryContainer data-testid="__checkout_payments_cash_on_delivery__">
      <CodIcon width={32} height={32} />
      <Box ml="12px">
        <Container fontWeight={TYPOGRAPHY.WEIGHT[700]} color="inherit">
          {t('order_details.payments.cash_on_delivery')}{' '}
        </Container>

        <PriceText as="box" fontSize={1}>
          {totalCodFee && totalCodFee.value > 0
            ? `Additional Fee of ${getFormattedPrice(totalCodFee, false, true, true)}`
            : t('paymentForm.noAdditonalFee')}
        </PriceText>
      </Box>
    </CashOnDeliveryContainer>
  );
};

export default CashOnDeliveryItem;
